const Maintenance = () => {
  return (
    <div className="app">
      <div className="container-fluid p-0 mb-5">
        <div className="maintenance">
          <h1 className="home-title fw-700 text-white mb-3">
            Nous serons de retour bientôt
          </h1>
          <p className="fs-5 text-white-50 mb-5 animated slideInDown">
            Désolé pour cette interruption. Nous sommes en plein dans la mise à
            jour de notre site. <br />
            Nous serons disponible d'ici peu. <br />
            <br />
            <br />
            -- L'équipe Tech APEA
          </p>
        </div>
      </div>
    </div>
  );
};

export default Maintenance;
